import { ProjectTemplateVersionGeneratedEntity } from "./generated/ProjectTemplateVersionGeneratedEntity";

export abstract class ProjectTemplateVersionEntity extends ProjectTemplateVersionGeneratedEntity {
    // Comment to preserve new line
}
